import React, { Component } from "react";
import { FaTrashAlt } from "react-icons/fa";
import themeLarge from "../ThemeLarge";

class DraftBlogsList extends Component {
  render() {
    const { draftBlogs, onEdit, onDelete } = this.props;

    const sortedDrafts = [...draftBlogs].sort((a, b) => {
      const aTime = a.updatedAt?.seconds
        ? a.updatedAt.seconds
        : new Date(a.updatedAt).getTime() / 1000;
      const bTime = b.updatedAt?.seconds
        ? b.updatedAt.seconds
        : new Date(b.updatedAt).getTime() / 1000;
      return bTime - aTime;
    });

    return (
      <div className="row" style={{ overflowY: "auto", padding: "10px" }}>
        <p
          style={{
            marginTop: 10,
            fontFamily: "Kumbh Sans",
            paddingBottom: "10px",
            fontSize: themeLarge.fontSize.h3,
            color: themeLarge.colors.text,
            fontWeight: 500,
          }}
        >
          Draft Blogs
        </p>

        {sortedDrafts.length === 0 ? (
          <p
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.body,
            }}
          >
            No draft blogs available.
          </p>
        ) : (
          sortedDrafts.map((blog, index) => {
            const isLocal = !blog.id;
            const cacheKey = blog.cacheKey || blog.localCacheKey;
            const editKey = isLocal ? cacheKey : blog.id;
            const onClickId = isLocal ? `cache:${cacheKey}` : blog.id;

            return (
              <div
                key={editKey}
                onClick={() => onEdit(onClickId)}
                className="d-flex justify-content-between align-items-center mb-2"
                style={{
                  cursor: "pointer",
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                  padding: "12px 20px",
                  borderRadius: "5px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#e0e0e0";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    index % 2 === 0 ? "#f9f9f9" : "#ffffff";
                }}
              >
                {/* Title (left aligned) */}
                <div
                  className="text-truncate"
                  style={{
                    flex: 1,
                    fontWeight: "bold",
                    fontFamily: "Kumbh Sans",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    marginRight: "20px",
                  }}
                >
                  {blog.title}
                </div>

                {/* Right side group: Badge, Updated Time, Delete */}
                <div className="d-flex align-items-center gap-3">
                  {isLocal && (
                    <span
                      title="Unsynced Local Draft"
                      style={{
                        padding: "3px 10px",
                        borderWidth: "1px",
                        borderColor: themeLarge.colors.text,
                        borderRadius: "15px",
                        borderStyle: "dotted",
                        fontSize: themeLarge.fontSize.small,
                        fontFamily: "Kumbh Sans",
                        whiteSpace: "nowrap",
                      }}
                    >
                      📝 Local Draft
                    </span>
                  )}

                  <div
                    className="text-nowrap"
                    style={{ fontSize: themeLarge.fontSize.small }}
                  >
                    <small>
                      Last updated:{" "}
                      {new Date(
                        blog.updatedAt?.seconds
                          ? blog.updatedAt.seconds * 1000
                          : new Date(blog.updatedAt).getTime()
                      ).toLocaleString()}
                    </small>
                  </div>

                  <button
                    className="btn btn-link text-danger"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(isLocal ? cacheKey : blog.id);
                    }}
                    title="Delete Blog"
                  >
                    <FaTrashAlt />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    );
  }
}

export default DraftBlogsList;
